export default __webpack_public_path__ + "static/media/mongoose.d5368230.webp";